import React, { PropsWithChildren } from "react"

export type HandleSubmitHandler = (e: React.FormEvent<HTMLFormElement>) => Promise<void>;

export type FormProps = {
  handleSubmit: HandleSubmitHandler;
}

export default function Form({handleSubmit, children}: PropsWithChildren<FormProps>) {
  return (
    <form
      onSubmit={handleSubmit}
      style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
    >
      {children}
    </form>
  )
}
